import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/services/api';
import { camelCase, mapKeys } from 'lodash';

Vue.use(Vuex);

const transformArrayObjectKeys = array => array.map(obj => mapKeys(obj, (v, k) => camelCase(k)));

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    hotelsAll: [],
    roomsAll: [],
    hotelFacilitiesList: [],

    hotelsRaw: [],
    hotelRawImages: [],
    hotelRawFacilities: [],
    roomsRaw: [],
    roomImagesRaw: [],
    hotelDescriptionsRaw: {},
    hotelMappingsRaw: [],
    roomAmenitiesRaw: [],
  },
  mutations: {
    SET_ALL_HOTELS(state, payload) {
      state.hotelsAll = payload;
    },
    SET_ALL_ROOMS(state, payload) {
      state.roomsAll = payload;
    },
    SET_HOTELS(state, payload) {
      state.hotelsRaw = transformArrayObjectKeys(payload);
    },
    SET_HOTEL_IMAGES(state, payload) {
      state.hotelRawImages = transformArrayObjectKeys(payload);
    },
    SET_HOTEL_FACILITIES(state, payload) {
      state.hotelRawFacilities = transformArrayObjectKeys(payload);
    },
    SET_HOTEL_FACILITIES_LIST(state, payload) {
      state.hotelFacilitiesList = payload;
    },
    SET_ROOMS(state, payload) {
      state.roomsRaw = transformArrayObjectKeys(payload);
    },
    SET_ROOM_IMAGES(state, payload) {
      state.roomImagesRaw = transformArrayObjectKeys(payload);
    },
    SET_HOTEL_MAPPINGS(state, payload) {
      state.hotelMappingsRaw = transformArrayObjectKeys(payload);
    },
    SET_ROOM_AMENITIES(state, payload) {
      state.roomAmenitiesRaw = transformArrayObjectKeys(payload);
    },
  },
  actions: {
    async getHotel(ctx, id) {
      const { data } = await api.get(`/data/converted/hotels/${id}.json`);
      return data;
    },
    async getHotelImages(ctx, id) {
      const { data } = await api.get(`/data/converted/hotels-images/${id}.json`);
      return data;
    },
    async getHotelFacilities(ctx, id) {
      const { data } = await api.get(`/data/converted/hotels-facilities/${id}.json`);
      return data;
    },
    async getHotelDescriptions(ctx, id) {
      const { data } = await api.get(`/data/converted/hotels-descriptions/${id}.json`);
      return data;
    },
    async getHotelSuppliersImages(ctx, id) {
      const { data } = await api.get(`/data/converted/suppliers/hotels-images/${id}.json`);
      return data;
    },
    async getHotelSuppliersFacilities(ctx, id) {
      const { data } = await api.get(`/data/converted/suppliers/hotels-facilities/${id}.json`);
      return data;
    },
    async getHotelSuppliersDescriptions(ctx, id) {
      const { data } = await api.get(`/data/converted/suppliers/hotels-descriptions/${id}.json`);
      return data;
    },
    async getHotelFacilitiesList({ commit, state }) {
      if (state.hotelFacilitiesList && state.hotelFacilitiesList.length > 0) return;
      const { data } = await api.get('/data/converted/list-hotel-facilities.json');
      commit('SET_HOTEL_FACILITIES_LIST', data);
      return data;
    },
    async getAllHotels({ commit, state }) {
      if (state.hotels && state.hotels.length > 0) return;
      const { data } = await api.get('/data/converted/hotels.json');
      commit('SET_ALL_HOTELS', data);
      return data;
    },
    async getAllRooms({ commit, state }) {
      if (state.rooms && state.rooms.length > 0) return;
      const { data } = await api.get('/data/converted/rooms.json');
      commit('SET_ALL_ROOMS', data);
      return data;
    },
    async getHotelRooms(ctx, id) {
      const { data } = await api.get(`/data/converted/rooms/${id}.json`);
      return data;
    },
    async getRoomImages(ctx, id) {
      const { data } = await api.get(`/data/converted/room-images/${id}.json`);
      return data;
    },
    async getHotelMappings(ctx, id) {
      const { data } = await api.get(`/data/converted/hotels-mappings/${id}.json`);
      return data;
    },
    async getHotelAutomation() {
      const { data } = await api.get('/data/converted/hotels-automation.json');
      return data;
    },
    async getHotelsShort() {
      const { data } = await api.get('/data/converted/hotels-short.json');
      return data;
    },
    async getRoomsDescription(ctx, id) {
      const { data } = await api.get(`/data/converted/room-description/${id}.json`);
      return data;
    },
    async getRoomsAmenities(ctx, id) {
      const { data } = await api.get(`/data/converted/room-amenities/${id}.json`);
      return data;
    },
    async getSuppliersList() {
      const { data } = await api.get('/data/converted/suppliers-list.json');
      return data;
    },
    async getCities() {
      const { data } = await api.get('/data/converted/hotels-cities.json');
      return data;
    },
    async getHotelsForAutocomplete(ctx) {

    },
  },
});
